import React from 'react';
import { styled, Colors } from 'themes';

const UserMarker = props => {
  const { numPoints, lat: latitude, lng: longitude, roleName } = props;

  let number = '';

  if (numPoints >= 1000) {
    number = `${Math.round(numPoints / 1000)}k`;
  } else if (numPoints > 1) {
    number = `${numPoints}`;
  }

  return (
    <Marker lat={latitude} lng={longitude} type={roleName}>
      {number}
    </Marker>
  );
};

export default UserMarker;

const Marker = styled.div`
  display: flex;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  font-weight: 700;
  color: white;
  font-size: 1rem;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  user-select: none;

  ${props => props.type === 'Yep' && `background-color: ${Colors.darkOrange}`}
  ${props =>
    props.type === 'Customer' && `background-color: ${Colors.darkOrange}`}
`;
